// extracted by mini-css-extract-plugin
export var chip = "_mf-2";
export var chipBody = "_mf-8";
export var chipHeader = "_mf-9";
export var chipWithKind = "_mf-7";
export var icon = "_mf-3";
export var kind = "_mf-a";
export var remove = "_mf-5";
export var removeIcon = "_mf-6";
export var row = "_mf-0";
export var rowHistorical = "_mf-1";
export var text = "_mf-4";